// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8560) return "static/chunks/8560-01b02c78423359c8.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 803 ? "cd24890f" : chunkId) + "." + {"803":"a7021f348e2d8459","1141":"a8de513797399bd7","4096":"1abed02a9af7e91f","6599":"945e68ce399ae503","8034":"192d725dd348b0f5"}[chunkId] + ".js";
};